import React from "react";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  style?: React.CSSProperties;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  placeholder = "Search...",
  style,
}) => {
  return (
    <div style={{ position: "relative", maxWidth: "300px", ...style }}>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: "100%",
          padding: "8px 40px 8px 12px",
          border: "1px solid #e0e0e0",
          borderRadius: "6px",
          fontSize: "14px",
          outline: "none",
        }}
      />
      <div
        style={{
          position: "absolute",
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          pointerEvents: "none",
        }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.848 15.0266C12.5649 16.0529 10.9374 16.6667 9.16663 16.6667C5.02449 16.6667 1.66663 13.3088 1.66663 9.16666C1.66663 5.02452 5.02449 1.66666 9.16663 1.66666C13.3088 1.66666 16.6666 5.02452 16.6666 9.16666C16.6666 10.9375 16.0529 12.5651 15.0265 13.8481L18.0891 16.9108C18.4146 17.2362 18.4146 17.7638 18.0891 18.0893C17.7637 18.4147 17.2361 18.4147 16.9106 18.0893L13.848 15.0266ZM3.33329 9.16666C3.33329 5.945 5.94496 3.33332 9.16663 3.33332C12.3883 3.33332 15 5.945 15 9.16666C15 10.7382 14.3785 12.1646 13.3679 13.2135C13.3393 13.2355 13.3118 13.2596 13.2856 13.2858C13.2594 13.312 13.2353 13.3395 13.2134 13.3681C12.1645 14.3786 10.7381 15 9.16663 15C5.94496 15 3.33329 12.3883 3.33329 9.16666Z"
            fill="#212121"
          />
        </svg>
      </div>
    </div>
  );
};
